import React, {useEffect} from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/branchModel";
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {
    deleteBranch,
    fetchBranches,
    resetCreateStatus,
    resetManageOwnerStatus,
    resetUpdateStatus,
} from "../../store/branch-slice";
import {fetchRestaurantList} from "../../store/list-slice";
import {useSearchParams} from "react-router-dom";

const BranchView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        manageOwnerStatus,
        error
    } = useSelector(state => state.branch);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    const list = useSelector(state => state.list);

    useEffect(() => {
        dispatch(fetchBranches({page: initialPage, limit: initialLimit}));
        dispatch(fetchRestaurantList());
    }, [dispatch, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (manageOwnerStatus === "success") {
            dispatch(resetManageOwnerStatus());
        }
    }, [dispatch, manageOwnerStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteBranch(id));
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items, list});

    return (
        <>
            <SubHeader title="All Branches">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}
        </>
    );
};

export default BranchView;
